import { ReactElement } from 'react';
import { FieldI } from './result';
import { Label, Value } from './styles';

const Field = ({ label, value }: FieldI): ReactElement => {
  return (
    <div>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </div>
  );
};

export default Field;
